import axios from "axios";

const API_URL = "/api";

// Produits
export const getProduits = (params) =>
  axios.get(`${API_URL}/produits`, { params });
export const getProduit = (id) => axios.get(`${API_URL}/produits/${id}`);
export const createProduit = (data) => axios.post(`${API_URL}/produits`, data);
export const bulkCreateProduits = (produits) => axios.post(`${API_URL}/produits/bulk`, { produits });
export const updateProduit = (id, data) =>
  axios.put(`${API_URL}/produits/${id}`, data);
export const deleteProduit = (id) => axios.delete(`${API_URL}/produits/${id}`);

// Images
export const uploadImage = (formData) =>
  axios.post(`${API_URL}/images/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
export const getImages = () => axios.get(`${API_URL}/images`);
export const deleteImage = (filename) =>
  axios.delete(`${API_URL}/images/${filename}`);

// Stock
export const getMouvementsStock = (params) =>
  axios.get(`${API_URL}/stock`, { params });
export const entreeStock = (data) =>
  axios.post(`${API_URL}/stock/entree`, data);
export const sortieStock = (data) =>
  axios.post(`${API_URL}/stock/sortie`, data);

// Fournisseurs
export const getFournisseurs = (actif) => {
  const params = actif !== undefined ? { actif } : {};
  return axios.get(`${API_URL}/fournisseurs`, { params });
};
export const getFournisseur = (id) =>
  axios.get(`${API_URL}/fournisseurs/${id}`);
export const createFournisseur = (data) =>
  axios.post(`${API_URL}/fournisseurs`, data);
export const updateFournisseur = (id, data) =>
  axios.put(`${API_URL}/fournisseurs/${id}`, data);
export const deleteFournisseur = (id) =>
  axios.delete(`${API_URL}/fournisseurs/${id}`);
export const toggleActiveFournisseur = (id) =>
  axios.patch(`${API_URL}/fournisseurs/${id}/toggle-active`);

// Fournisseurs - Contacts
export const addFournisseurContact = (id, data) =>
  axios.post(`${API_URL}/fournisseurs/${id}/contacts`, data);
export const updateFournisseurContact = (id, contactId, data) =>
  axios.put(`${API_URL}/fournisseurs/${id}/contacts/${contactId}`, data);
export const deleteFournisseurContact = (id, contactId) =>
  axios.delete(`${API_URL}/fournisseurs/${id}/contacts/${contactId}`);
export const setFournisseurContactPrincipal = (id, contactId) =>
  axios.patch(
    `${API_URL}/fournisseurs/${id}/contacts/${contactId}/set-principal`,
  );

// Fournisseurs - Classification
export const updateFournisseurTags = (id, data) =>
  axios.patch(`${API_URL}/fournisseurs/${id}/tags`, data);
export const updateFournisseurCategorie = (id, data) =>
  axios.patch(`${API_URL}/fournisseurs/${id}/categorie`, data);
export const updateFournisseurCriticite = (id, data) =>
  axios.patch(`${API_URL}/fournisseurs/${id}/criticite`, data);
export const updateFournisseurScore = (id, data) =>
  axios.patch(`${API_URL}/fournisseurs/${id}/score`, data);
export const searchFournisseurs = (data) =>
  axios.post(`${API_URL}/fournisseurs/search`, data);

// Fournisseurs - Conditions commerciales
export const updateFournisseurConditionsPaiement = (id, data) =>
  axios.patch(`${API_URL}/fournisseurs/${id}/conditions-paiement`, data);
export const addFournisseurCertification = (id, data) =>
  axios.post(`${API_URL}/fournisseurs/${id}/certifications`, data);
export const deleteFournisseurCertification = (id, certificationId) =>
  axios.delete(
    `${API_URL}/fournisseurs/${id}/certifications/${certificationId}`,
  );
export const updateFournisseurNotes = (id, data) =>
  axios.patch(`${API_URL}/fournisseurs/${id}/notes`, data);
export const getFournisseurStatistiques = (id) =>
  axios.get(`${API_URL}/fournisseurs/${id}/statistiques`);
export const getFournisseurArticles = (id) =>
  axios.get(`${API_URL}/fournisseurs/${id}/articles`);
export const addFournisseurArticle = (id, data) =>
  axios.post(`${API_URL}/fournisseurs/${id}/articles`, data);
export const updateFournisseurArticle = (id, articleId, data) =>
  axios.put(`${API_URL}/fournisseurs/${id}/articles/${articleId}`, data);
export const deleteFournisseurArticle = (id, articleId) =>
  axios.delete(`${API_URL}/fournisseurs/${id}/articles/${articleId}`);
export const getFournisseurCommandes = (id, params) =>
  axios.get(`${API_URL}/fournisseurs/${id}/commandes`, { params });
export const evaluerFournisseur = (id, data) =>
  axios.post(`${API_URL}/fournisseurs/${id}/evaluer`, data);
export const setFournisseurPrincipal = (id) =>
  axios.patch(`${API_URL}/fournisseurs/${id}/set-principal`);
export const getFournisseurRuptures = (id) =>
  axios.get(`${API_URL}/fournisseurs/${id}/ruptures`);
export const bulkFournisseursActions = (data) =>
  axios.post(`${API_URL}/fournisseurs/bulk/actions`, data);

// Catalogue Fournisseurs (Articles-Fournisseurs)
export const lierArticleFournisseur = (data) =>
  axios.post(`${API_URL}/catalogue-fournisseurs`, data);
export const getArticlesByFournisseur = (fournisseurId) =>
  axios.get(`${API_URL}/catalogue-fournisseurs/fournisseur/${fournisseurId}`);
export const getFournisseursByProduit = (produitId) =>
  axios.get(`${API_URL}/catalogue-fournisseurs/produit/${produitId}`);
export const updateArticleFournisseur = (id, data) =>
  axios.put(`${API_URL}/catalogue-fournisseurs/${id}`, data);
export const deleteArticleFournisseur = (id) =>
  axios.delete(`${API_URL}/catalogue-fournisseurs/${id}`);
export const updateTarifArticleFournisseur = (id, data) =>
  axios.patch(`${API_URL}/catalogue-fournisseurs/${id}/tarif`, data);
export const setPrixDegressifs = (id, data) =>
  axios.patch(`${API_URL}/catalogue-fournisseurs/${id}/prix-degressifs`, data);
export const getHistoriquePrix = (id, params) =>
  axios.get(`${API_URL}/catalogue-fournisseurs/${id}/historique-prix`, {
    params,
  });
export const updateDelaisLivraison = (id, data) =>
  axios.patch(`${API_URL}/catalogue-fournisseurs/${id}/delais`, data);
export const calculerPrixArticle = (id, data) =>
  axios.post(`${API_URL}/catalogue-fournisseurs/${id}/calculer-prix`, data);
export const searchCatalogueFournisseurs = (data) =>
  axios.post(`${API_URL}/catalogue-fournisseurs/search`, data);
export const importerCatalogueFournisseur = (data) =>
  axios.post(`${API_URL}/catalogue-fournisseurs/import`, data);

// Commandes Fournisseurs
export const getCommandes = (params) =>
  axios.get(`${API_URL}/commandes-fournisseurs`, { params });
export const getCommande = (id) =>
  axios.get(`${API_URL}/commandes-fournisseurs/${id}`);
export const createCommande = (data) =>
  axios.post(`${API_URL}/commandes-fournisseurs`, data);
// Ajoute un produit au brouillon de commande du fournisseur (créé si besoin)
export const ajouterProduitCommandeFournisseur = (data) =>
  axios.post(`${API_URL}/commandes-fournisseurs/ajouter-produit`, data);
export const updateCommande = (id, data) =>
  axios.put(`${API_URL}/commandes-fournisseurs/${id}`, data);
export const deleteCommande = (id) =>
  axios.delete(`${API_URL}/commandes-fournisseurs/${id}`);
export const envoyerCommande = (id) =>
  axios.patch(`${API_URL}/commandes-fournisseurs/${id}/envoyer`);
export const recevoirCommande = (id, data) =>
  axios.post(`${API_URL}/commandes-fournisseurs/${id}/recevoir`, data);
export const annulerCommande = (id) =>
  axios.patch(`${API_URL}/commandes-fournisseurs/${id}/annuler`);
export const getDettesFournisseurs = (params) =>
  axios.get(`${API_URL}/commandes-fournisseurs/dettes`, { params });
export const payerCommandeFournisseur = (id, data) =>
  axios.post(`${API_URL}/commandes-fournisseurs/${id}/paiements`, data);
export const getBonPaiementFournisseurPDF = (commandeId, paiementId) =>
  axios.get(`${API_URL}/commandes-fournisseurs/${commandeId}/paiements/${paiementId}/pdf`, { responseType: 'blob' });

// Bons de Commande (Appro)
export const creerBonCommande = (data) =>
  axios.post(`${API_URL}/bons-commande`, data);
export const getBonsCommande = (params) =>
  axios.get(`${API_URL}/bons-commande`, { params });
export const getBonCommande = (id) =>
  axios.get(`${API_URL}/bons-commande/${id}`);
export const modifierBonCommande = (id, data) =>
  axios.put(`${API_URL}/bons-commande/${id}`, data);
export const envoyerBonCommande = (id, data) =>
  axios.patch(`${API_URL}/bons-commande/${id}/envoyer`, data);
export const confirmerBonCommande = (id, data) =>
  axios.patch(`${API_URL}/bons-commande/${id}/confirmer`, data);
export const annulerBonCommande = (id, data) =>
  axios.patch(`${API_URL}/bons-commande/${id}/annuler`, data);
export const receptionPartielle = (id, data) =>
  axios.post(`${API_URL}/bons-commande/${id}/reception-partielle`, data);
export const validerReception = (id, data) =>
  axios.post(`${API_URL}/bons-commande/${id}/valider-reception`, data);
export const relancerBonCommande = (id, data) =>
  axios.post(`${API_URL}/bons-commande/${id}/relancer`, data);
export const getCommandesEnRetard = () =>
  axios.get(`${API_URL}/bons-commande/en-retard`);
export const getStatistiquesCommandes = (params) =>
  axios.get(`${API_URL}/bons-commande/statistiques`, { params });

// Transferts de Stock
export const getTransferts = (params) =>
  axios.get(`${API_URL}/transferts-stock`, { params });
export const getTransfert = (id) =>
  axios.get(`${API_URL}/transferts-stock/${id}`);
export const createTransfert = (data) =>
  axios.post(`${API_URL}/transferts-stock`, data);
export const updateTransfert = (id, data) =>
  axios.put(`${API_URL}/transferts-stock/${id}`, data);
export const deleteTransfert = (id) =>
  axios.delete(`${API_URL}/transferts-stock/${id}`);
export const validerTransfert = (id) =>
  axios.patch(`${API_URL}/transferts-stock/${id}/valider`);
export const expedierTransfert = (id, data) =>
  axios.post(`${API_URL}/transferts-stock/${id}/expedier`, data);
export const recevoirTransfert = (id, data) =>
  axios.post(`${API_URL}/transferts-stock/${id}/recevoir`, data);
export const annulerTransfert = (id, data) =>
  axios.patch(`${API_URL}/transferts-stock/${id}/annuler`, data);
export const getBonTransfertPDF = (id) =>
  axios.get(`${API_URL}/transferts-stock/${id}/pdf`, { responseType: 'blob' });

// Boutiques
export const getBoutiques = (params) =>
  axios.get(`${API_URL}/boutiques`, { params });
export const getBoutique = (id) => axios.get(`${API_URL}/boutiques/${id}`);

// Entrepôts
export const getEntrepots = () => axios.get(`${API_URL}/entrepots`);
export const getEntrepot = (id) => axios.get(`${API_URL}/entrepots/${id}`);
export const createEntrepot = (data) =>
  axios.post(`${API_URL}/entrepots`, data);
export const updateEntrepot = (id, data) =>
  axios.put(`${API_URL}/entrepots/${id}`, data);
export const deleteEntrepot = (id) =>
  axios.delete(`${API_URL}/entrepots/${id}`);
export const toggleActiveEntrepot = (id) =>
  axios.patch(`${API_URL}/entrepots/${id}/toggle-active`);

// Plan de l'entrepôt : rayons & emplacements (distinct des « Rayons » catégories produits)
export const addEntrepotRayon = (entrepotId, data) =>
  axios.post(`${API_URL}/entrepots/${entrepotId}/rayons`, data);
export const updateEntrepotRayon = (entrepotId, rayonId, data) =>
  axios.put(`${API_URL}/entrepots/${entrepotId}/rayons/${rayonId}`, data);
export const deleteEntrepotRayon = (entrepotId, rayonId) =>
  axios.delete(`${API_URL}/entrepots/${entrepotId}/rayons/${rayonId}`);
export const addEntrepotEmplacement = (entrepotId, rayonId, data) =>
  axios.post(`${API_URL}/entrepots/${entrepotId}/rayons/${rayonId}/emplacements`, data);
export const updateEntrepotEmplacement = (entrepotId, rayonId, empId, data) =>
  axios.put(`${API_URL}/entrepots/${entrepotId}/rayons/${rayonId}/emplacements/${empId}`, data);
export const deleteEntrepotEmplacement = (entrepotId, rayonId, empId) =>
  axios.delete(`${API_URL}/entrepots/${entrepotId}/rayons/${rayonId}/emplacements/${empId}`);

// Stock Entrepôt
export const getStockByEntrepot = (produitId) =>
  axios.get(`${API_URL}/stock-entrepot/distribution/${produitId}`);
export const getEmplacementsProduit = (produitId) =>
  axios.get(`${API_URL}/stock-entrepot/emplacements-produit/${produitId}`);
export const getAllStockDistributions = () =>
  axios.get(`${API_URL}/stock-entrepot/distributions`);
export const getStockEntrepot = (entrepotId) =>
  axios.get(`${API_URL}/stock-entrepot/entrepot/${entrepotId}`);
export const importStockEntrepot = (data) =>
  axios.post(`${API_URL}/stock-entrepot/import`, data);
export const importStockMultiEntrepots = (data) =>
  axios.post(`${API_URL}/stock-entrepot/import-multi`, data);
// Inventaires
export const getInventaires = (params) =>
  axios.get(`${API_URL}/inventaires`, { params });
export const getInventaire = (id) =>
  axios.get(`${API_URL}/inventaires/${id}`);
export const createInventaire = (data) =>
  axios.post(`${API_URL}/inventaires`, data);
export const saisirLignesInventaire = (id, data) =>
  axios.patch(`${API_URL}/inventaires/${id}/lignes`, data);
export const ajouterLigneInventaire = (id, data) =>
  axios.post(`${API_URL}/inventaires/${id}/lignes`, data);
// data : { produit, emplacement } ou { produit, reset: true }
export const changerEmplacementLigneInventaire = (id, data) =>
  axios.patch(`${API_URL}/inventaires/${id}/lignes/emplacement`, data);
export const validerInventaire = (id) =>
  axios.post(`${API_URL}/inventaires/${id}/valider`);
export const annulerInventaire = (id) =>
  axios.post(`${API_URL}/inventaires/${id}/annuler`);
export const getInventairePDF = (id) =>
  axios.get(`${API_URL}/inventaires/${id}/pdf`, { responseType: 'blob' });

// Placement par emplacement
export const getEntrepotEmplacementStock = (entrepotId) =>
  axios.get(`${API_URL}/stock-entrepot/entrepot/${entrepotId}/emplacements`);
export const placerStock = (data) =>
  axios.post(`${API_URL}/stock-entrepot/placer`, data);

// Ventes
export const getVentes = (params) => axios.get(`${API_URL}/ventes`, { params });
export const getVente = (id) => axios.get(`${API_URL}/ventes/${id}`);
export const createVente = (data) => axios.post(`${API_URL}/ventes`, data);
export const updateVente = (id, data) => axios.put(`${API_URL}/ventes/${id}`, data);
export const finaliserVente = (id, data) => axios.post(`${API_URL}/ventes/${id}/finaliser`, data);
export const annulerVente = (id) =>
  axios.put(`${API_URL}/ventes/${id}/annuler`);
export const getFacturePDF = (id) =>
  axios.get(`${API_URL}/ventes/${id}/pdf`, { responseType: "blob" });
export const getTicketPDF = (id) =>
  axios.get(`${API_URL}/ventes/${id}/ticket-pdf`, { responseType: "blob" });

// Dashboard
export const getStats = () => axios.get(`${API_URL}/dashboard/stats`);

// Configuration
export const getConfigurations = () => axios.get(`${API_URL}/configuration`);
export const getConfiguration = (cle) =>
  axios.get(`${API_URL}/configuration/${cle}`);
export const updateConfiguration = (cle, data) =>
  axios.put(`${API_URL}/configuration/${cle}`, data);
export const initConfigurations = () =>
  axios.post(`${API_URL}/configuration/init`);
export const getTopProduits = (periode) =>
  axios.get(`${API_URL}/dashboard/top-produits`, { params: { periode } });
export const getEvolutionVentes = (jours) =>
  axios.get(`${API_URL}/dashboard/evolution-ventes`, { params: { jours } });
export const getAlertesStock = () =>
  axios.get(`${API_URL}/dashboard/alertes-stock`);
export const getRapportBoutique = (params) =>
  axios.get(`${API_URL}/dashboard/rapport-boutique`, { params });
export const getProduitsVendusJour = (params) =>
  axios.get(`${API_URL}/dashboard/produits-vendus-jour`, { params });

// Clients
export const getClients = (params) =>
  axios.get(`${API_URL}/clients`, { params });
export const getClient = (id) => axios.get(`${API_URL}/clients/${id}`);
export const createClient = (data) => axios.post(`${API_URL}/clients`, data);
export const updateClient = (id, data) =>
  axios.put(`${API_URL}/clients/${id}`, data);
export const deleteClient = (id) => axios.delete(`${API_URL}/clients/${id}`);
export const getClientDettes = (id) =>
  axios.get(`${API_URL}/clients/${id}/dettes`);
export const getClientHistorique = (id) =>
  axios.get(`${API_URL}/clients/${id}/historique`);

// Réajustement / effacement de dette client
export const ajusterDetteClient = (clientId, data) =>
  axios.post(`${API_URL}/dettes/client/${clientId}/ajuster`, data);
export const getAjustementsDette = (clientId) =>
  axios.get(`${API_URL}/dettes/client/${clientId}/ajustements`);
export const revoquerAjustementDette = (lotId) =>
  axios.delete(`${API_URL}/dettes/ajustements/${lotId}`);

// Paiements
export const getPaiements = (params) =>
  axios.get(`${API_URL}/paiements`, { params });
export const getPaiement = (id) => axios.get(`${API_URL}/paiements/${id}`);
export const createPaiement = (data) =>
  axios.post(`${API_URL}/paiements`, data);
export const payerDetteClient = (clientId, data) =>
  axios.post(`${API_URL}/paiements/client/${clientId}`, data);
export const deletePaiement = (id) =>
  axios.delete(`${API_URL}/paiements/${id}`);
export const getVentePaiements = (venteId) =>
  axios.get(`${API_URL}/ventes/${venteId}/paiements`);
export const getBonPaiementPDF = (paiementId) =>
  axios.get(`${API_URL}/paiements/${paiementId}/pdf`, { responseType: 'blob' });

// Utilisateurs
export const getUtilisateurs = () => axios.get(`${API_URL}/users`);
export const getUtilisateur = (id) => axios.get(`${API_URL}/users/${id}`);
export const updateUtilisateur = (id, data) =>
  axios.put(`${API_URL}/users/${id}`, data);
export const deleteUtilisateur = (id) => axios.delete(`${API_URL}/users/${id}`);

// Caisses journalières
export const getCaisses = (params) => axios.get(`${API_URL}/caisses`, { params });
export const getCaisseActive = (boutiqueId) => axios.get(`${API_URL}/caisses/active`, { params: boutiqueId ? { boutiqueId } : {} });
export const getCaisse = (id) => axios.get(`${API_URL}/caisses/${id}`);
export const ouvrirCaisse = (data) => axios.post(`${API_URL}/caisses/ouvrir`, data);
export const fermerCaisse = (data) => axios.post(`${API_URL}/caisses/fermer`, data);
export const addMouvementCaisse = (caisseId, data) => axios.post(`${API_URL}/caisses/${caisseId}/mouvements`, data);
export const getMouvementsCaisse = (caisseId) => axios.get(`${API_URL}/caisses/${caisseId}/mouvements`);
export const getJournalCaissePDF  = (id) => axios.get(`${API_URL}/caisses/${id}/pdf/journal`,  { responseType: 'blob' });
export const getRapportCloturePDF = (id) => axios.get(`${API_URL}/caisses/${id}/pdf/cloture`,  { responseType: 'blob' });
export const getBonSortiePDF      = (id, mouvementId) => axios.get(`${API_URL}/caisses/${id}/mouvements/${mouvementId}/pdf/bon-sortie`, { responseType: 'blob' });

// Retours produits
export const getRetours       = (params) => axios.get(`${API_URL}/retours`, { params });
export const getRetour        = (id)     => axios.get(`${API_URL}/retours/${id}`);
export const createRetour     = (data)   => axios.post(`${API_URL}/retours`, data);
export const approuverRetour  = (id, data) => axios.patch(`${API_URL}/retours/${id}/approuver`, data);
export const rejeterRetour    = (id, data) => axios.patch(`${API_URL}/retours/${id}/rejeter`, data);
export const completerRetour  = (id, data) => axios.patch(`${API_URL}/retours/${id}/completer`, data);
export const deleteRetour     = (id)     => axios.delete(`${API_URL}/retours/${id}`);

// Politiques de retour
export const getPolitiquesRetour   = ()       => axios.get(`${API_URL}/politiques-retour`);
export const createPolitiqueRetour = (data)   => axios.post(`${API_URL}/politiques-retour`, data);
export const updatePolitiqueRetour = (id, data) => axios.put(`${API_URL}/politiques-retour/${id}`, data);
export const deletePolitiqueRetour = (id)     => axios.delete(`${API_URL}/politiques-retour/${id}`);
export const togglePolitiqueRetour = (id)     => axios.patch(`${API_URL}/politiques-retour/${id}/toggle`);


// ═══════════════════════════════════════════════════════════════
// MODULE MARKETING
// ═══════════════════════════════════════════════════════════════

// --- CRM funnel (Module 1) ---
export const getCrmBoard       = (pipelineId) => axios.get(`${API_URL}/crm/pipeline/board`, { params: pipelineId ? { pipelineId } : {} });
export const getCrmPipelines   = ()            => axios.get(`${API_URL}/crm/pipelines`);
export const captureLead       = (data)        => axios.post(`${API_URL}/crm/leads`, data);
export const importLeads       = (data)        => axios.post(`${API_URL}/crm/leads/import`, data);
export const moveLeadStage     = (id, stageId) => axios.patch(`${API_URL}/crm/leads/${id}/stage`, { stageId });
export const getCrmContacts    = (params)      => axios.get(`${API_URL}/crm/contacts`, { params });
export const getCrmContact     = (id)          => axios.get(`${API_URL}/crm/contacts/${id}`);

// --- Creative Studio (Module 2) ---
export const generateCreative     = (data)   => axios.post(`${API_URL}/creative/creatives`, data);
export const getCreatives         = (params) => axios.get(`${API_URL}/creative/creatives`, { params });
export const getCreative          = (id)     => axios.get(`${API_URL}/creative/creatives/${id}`);
export const getCreativeTemplates = ()       => axios.get(`${API_URL}/creative/templates`);

// --- Social Publisher (Module 3) ---
export const createPost          = (data)              => axios.post(`${API_URL}/publishing/posts`, data);
export const schedulePost        = (id, scheduledAt)   => axios.post(`${API_URL}/publishing/posts/${id}/schedule`, { scheduledAt });
export const publishPostNow      = (id)                => axios.post(`${API_URL}/publishing/posts/${id}/publish`);
export const cancelPost          = (id)                => axios.post(`${API_URL}/publishing/posts/${id}/cancel`);
export const getPosts            = (params)            => axios.get(`${API_URL}/publishing/posts`, { params });
export const getPost             = (id)                => axios.get(`${API_URL}/publishing/posts/${id}`);
export const getMessageTemplates = ()                  => axios.get(`${API_URL}/publishing/message-templates`);

// --- Attribution / Analytics (Module 4) ---
export const getCampaigns          = ()     => axios.get(`${API_URL}/analytics/campaigns`);
export const createCampaign        = (data) => axios.post(`${API_URL}/analytics/campaigns`, data);
export const getCampaignConversions= (id)   => axios.get(`${API_URL}/analytics/campaigns/${id}/conversions`);
export const getAttributionDashboard = ()   => axios.get(`${API_URL}/analytics/dashboard`);

// --- Fidélité / Loyalty (Module 5) ---
export const getLoyaltyCards    = (params) => axios.get(`${API_URL}/loyalty/cards`, { params });
export const getLoyaltyCard     = (id)     => axios.get(`${API_URL}/loyalty/cards/${id}`);
export const adjustLoyaltyPoints= (data)   => axios.post(`${API_URL}/loyalty/cards/adjust`, data);
export const getLoyaltyRewards  = (params) => axios.get(`${API_URL}/loyalty/rewards`, { params });
export const createLoyaltyReward= (data)   => axios.post(`${API_URL}/loyalty/rewards`, data);
export const updateLoyaltyReward= (id, data)=> axios.put(`${API_URL}/loyalty/rewards/${id}`, data);
export const deleteLoyaltyReward= (id)     => axios.delete(`${API_URL}/loyalty/rewards/${id}`);
export const redeemLoyaltyReward= (data)   => axios.post(`${API_URL}/loyalty/redeem`, data);
export const getLoyaltyOverview = ()       => axios.get(`${API_URL}/loyalty/overview`);
export const runLoyaltyMaintenance = ()    => axios.post(`${API_URL}/loyalty/maintenance/run`);
export const getLoyaltyCoupons  = (clientId)=> axios.get(`${API_URL}/loyalty/coupons`, { params: { clientId } });
export const consumeLoyaltyCoupon = (id, data) => axios.post(`${API_URL}/loyalty/coupons/${id}/use`, data);
